export const TIP_RETURN_LOCALE_STORAGE_KEY = "walkative_tip_return_locale";
export const TIP_RETURN_CONTEXT_STORAGE_KEY = "walkative_tip_return_context";

export const TIP_RETURN_LOCALES = ["en", "es", "de", "pl"] as const;

export type TipReturnLocale = (typeof TIP_RETURN_LOCALES)[number];
export type TipReturnResult = "success" | "cancel" | "unknown";

export type TipReturnContext = {
  locale: TipReturnLocale;
  guideSlug: string;
};

export function isTipReturnLocale(value: unknown): value is TipReturnLocale {
  return (
    typeof value === "string" &&
    TIP_RETURN_LOCALES.includes(value as TipReturnLocale)
  );
}

export function isTipReturnGuideSlug(value: unknown): value is string {
  return (
    typeof value === "string" &&
    value.length > 0 &&
    value.length <= 160 &&
    /^[a-zA-Z0-9_-]+$/.test(value)
  );
}

export function tipReturnContext(
  locale: unknown,
  guideSlug: unknown,
): TipReturnContext | null {
  if (!isTipReturnLocale(locale) || !isTipReturnGuideSlug(guideSlug)) {
    return null;
  }
  return { locale, guideSlug };
}

export function parseTipReturnContext(
  value: string | null,
): TipReturnContext | null {
  if (!value) return null;
  try {
    const parsed = JSON.parse(value) as Record<string, unknown>;
    return tipReturnContext(parsed.locale, parsed.guideSlug);
  } catch {
    return null;
  }
}

export function tipReturnResult(value: unknown): TipReturnResult {
  if (value === "success" || value === "cancel") return value;
  return "unknown";
}
